"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketPolicyInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketPolicyInput.js.map